import React, { ChangeEvent, useCallback, useState ,useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import { useLocation , Link ,useNavigate} from 'react-router-dom';
import MbpAthnUi from 'Utils/MbpAthn'
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import MbpAthnRsltVrfRqstApi from 'Apis/MbpAthnRsltVrfRqstApi';
import LoginIdDupChkApi from 'Apis/LoginIdDupChkApi';
import { Helmet } from 'react-helmet-async';
import MembJoinApi from 'Apis/MembJoinApi';
import RcmdrCdVrfApi from 'Apis/RcmdrCdVrfApi';
import useRecaptcha from 'Utils/useRecaptcha';
import MbpAthnTknInqApi from 'Apis/MbpAthnTknInqApi';
import NickNameVrfApi from 'Apis/NickNameChkApi';
import { validateInput } from 'Utils/XssFilter';
import EtcCtxtApi from 'Apis/EtcCtxtApi';
import ApiError from 'Utils/ApiError';
import { useDebounce } from 'Utils/useDebounce';
import CbtMembJoinApi from 'Apis/CbtMembJoinApi';
import ReactGA from 'react-ga4';
import 'Assets/css/MembJoin.css';
import TrmsCtxtUi from 'Views/Trms/TrmsCtxtUi';
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
import ApiResultModal from 'Components/ApiResultModal';
declare global {
    interface Window { kmcRespFunc: any; }
}

const AppMembJoinFormUi = () => {
    const navigate = useNavigate();
    const {isLoading,error,data: langData}:any = UseLangLstQuery( );
    const [loginIdInputVal,setLoginIdInputVal] = useState("");
    const [membRcmdrCdInputVal,setMembRcmdrCdInputVal] = useState("");
    const [membNickNameInputVal,setMembNickNameInputVal] = useState("");
    const [passwdInputVal,setPasswdInputVal] = useState("");
    const [identMthCd,setIdentMthCd] = useState("EML");
    const [passwdChkVal,setPasswdChkVal] = useState("");
    const [showPassword,setShowPassword] = useState(false);
    const [mbpBnftState,setBnftState] =useState(false);
    const [trmsMdalState,setTrmsMdalState] = useState(false);
    const [trmsMdalTitlState,setTrmsMdalTitlState] = useState("");
    const [trmsMdalCtxtState,setTrmsMdalCtxtState] = useState("");
    const [loginIdRsltVal,setLoginIdRsltVal] = useState<string|null>(null);
    const [passwdRsltVal,setPasswdRsltVal] = useState<string|null>(null);
    const [membRcmdrCdRsltVal,setMembRcmdrCdRsltVal] = useState<string|null>(null);
    const [membNickNameRsltVal,setMembNickNameRsltVal] = useState<string>("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const location = useLocation();
    const [joinTypeCd, setJoinTypeCd] = useState<string>(location.state?.joinTypeCd || "MGP");
    const prevJoinTypeRef = useRef<string | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    const { push: gtmPush } = useGtm();
    
    // Read and normalize referrer query parameter.
    const params = new URLSearchParams(window.location.search);
    const referrerParam = params.get("referrer");
    const referrer = (referrerParam && referrerParam !== "null") ? referrerParam : "/";
    const app = params.get("app") || "";
    
    const [gndrKindCd,setGndrKindCd] = useState<string|null>(null);
    const [dobInputVal,setDobInputVal] = useState<string>("");
    const [rlnmInputVal,setRlnmInputVal] = useState<string>("");
    const [emlNtfyRecvYn,setEmlNtfyRecvYn] = useState("N");
    const [smsNtfyRecvYn,setSmsNtfyRecvYn] = useState("N");
    let emlAddr:string = location.state?.emlAddr;
    

    // alert setting
    const [loginIdAlertTxt,setLoginIdAlertTxt] = useState("");
    const [loginIdAlertState,setLoginIdAlertState] = useState("N");
    const [rcmdrCdAlertState,setRcmdrCdAlertState] = useState("N");
    const [nickNameAlertState,setNickNameAlertState] = useState("N");
    const [rcmdrCdAlertTxt,setRcmdrCdAlertTxt] = useState("");
    const [nickNameAlertTxt,setNickNameAlertTxt] = useState("");
    const [passwdAlertTxt,setPasswdAlertTxt] = useState("");
    const [passwdAlertState,setPasswdAlertState] = useState("Y");
    const [passwdChkAlertTxt,setPasswdChkAlertTxt] = useState("");
    const [passwdChkAlertState,setPasswdChkAlertState] = useState("N");
    const [dobChkAlertTxt,setDobChkAlertTxt] = useState("");
    const [trmsMktgState,setTrmsMktgState] = useState("");
    const [agreChkState,setAgreChkState] = useState<string[]>([]);
    
    let loginIdInputDesc ="";
    let rcmdrCdInputDesc ="";
    let nickNameInputDesc ="";
    const loginIdRole =  /^[0-9a-zA-Z][0-9a-zA-Z._-]{4,28}[0-9a-zA-Z]$/;
    const passWdRole = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@\$%\^&\*_\~\-])[A-Za-z\d!@\$%\^&\*_\~\-]{8,30}$/;
    const dobRole = /^[0-9]{8}$/;
    const PASSWD_RULE_MSG = langData && langData.MEMB_FIND_PASSWD_INPUT_DESC_01;

     
    const LoginIdInputValHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setLoginIdRsltVal(null);
        // Apply XSS filter while keeping user input intent.
        const filteredValue = validateInput(event.currentTarget.value.replace(/\s/g, ''), 'loginId', false);
        setLoginIdInputVal(filteredValue);
    }
    const LoginIdFocusHandler = () => {
        setLoginIdAlertTxt("");
        setLoginIdAlertState("N");
    }
    const MembRcmdrCdInputValHandler = (event:ChangeEvent<HTMLInputElement>) => {
        // Apply XSS filter while keeping user input intent.
        const filteredValue = validateInput(event.currentTarget.value.replace(/\s/g, ''), 'referrerCode', false);
        setMembRcmdrCdInputVal(filteredValue);
        // Keep latest typed referrer code result in sync.
        setMembRcmdrCdRsltVal(filteredValue || null);
    }
    const MembNickNameInputValHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setMembNickNameRsltVal("");
        // Apply XSS filter for nickname before updating state.
        const filteredValue = validateInput(event.currentTarget.value.replace(/\s/g, ''), 'nickname', true);
        setMembNickNameInputVal(filteredValue);
    }
    const PasswdInputHandler = (event:ChangeEvent<HTMLInputElement>) => {
        // Apply XSS filter while keeping user input intent.
        const filteredValue = validateInput(event.currentTarget.value.replace(/\s/g, ''), 'password', false);
        setPasswdInputVal(filteredValue);
        
        // Validate password rule in real time.
        if(filteredValue.length > 0 && !passWdRole.test(filteredValue)) {
            setPasswdAlertState("N");
            setPasswdAlertTxt(PASSWD_RULE_MSG);
            setPasswdRsltVal(null);
        } else if(filteredValue.length > 0 && passWdRole.test(filteredValue)) {
            setPasswdAlertState("Y");
            setPasswdAlertTxt(langData && langData.MEMB_JOIN_PASSWD_AVAILABLE_00 || "사용 가능한 비밀번호입니다.");
            setPasswdRsltVal(filteredValue);
        } else {
            setPasswdAlertTxt("");
            setPasswdAlertState("N");
            setPasswdRsltVal(null);
        }
    }
    const PasswdBlurHandler = () => {
        // Re-validate password format on blur.
        if(passwdInputVal.length > 0 && !passWdRole.test(passwdInputVal)) {
            setPasswdAlertState("N");
            setPasswdAlertTxt(PASSWD_RULE_MSG);
        }
    }
    const PasswdFocusHandler = () => {
        // If input exists, check it immediately when focused.
        if(passwdInputVal.length > 0 && !passWdRole.test(passwdInputVal)) {
            setPasswdAlertState("N");
            setPasswdAlertTxt(PASSWD_RULE_MSG);
        } else {
            setPasswdAlertTxt("");
            setPasswdAlertState("N");
        }
    }
    const DobHandler = (event:any) => {
        // Apply XSS filter while keeping user input intent.
        const filteredValue = validateInput(event.currentTarget.value.replace(/\s/g, ''), 'dateOfBirth', false);
        
        if(!dobRole.test(filteredValue)){
            setDobChkAlertTxt(langData && langData.MEMB_JOIN_DOB_INVALID_00 || "생년월일을 8자리 숫자(YYYYMMDD)로 입력해주세요.");
        } else {
            setDobChkAlertTxt("");
        }
        setDobInputVal(filteredValue);
    }
    const rlnmHandler = (event:any) => {
        // Apply XSS filter while keeping user input intent.
        const filteredValue = validateInput(event.currentTarget.value.replace(/\s/g, ''), 'realName', false);
        setRlnmInputVal(filteredValue);
    }
    const GndrHandler = (event:ChangeEvent<HTMLInputElement>) => {
        setGndrKindCd(event.currentTarget.value);
    }
    const EmlNtfyRecvHandler = (event:ChangeEvent<HTMLInputElement>) => {
        if(event.currentTarget.checked ==true) {
            setEmlNtfyRecvYn("Y");
        }else {
            setEmlNtfyRecvYn("N");  
        }
    }
    
    const SmsNtfyRecvHandler = (event:ChangeEvent<HTMLInputElement>) => {
        if(event.currentTarget.checked ==true) {
            setSmsNtfyRecvYn("Y");
        }else {
            setSmsNtfyRecvYn("N");  
        }
    }
    const AgreMtkgFunc = (event:ChangeEvent<HTMLInputElement>) => {
        if(event.currentTarget.checked ==true) {
            setEmlNtfyRecvYn("Y");
            setSmsNtfyRecvYn("Y");
        }else {
            setEmlNtfyRecvYn("N");
            setSmsNtfyRecvYn("N");  
        }
    }

    const AgreTrmsFunc = (event:ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.currentTarget;
        if(checked) {
            setAgreChkState((prev) => prev.includes(name) ? prev : [...prev, name]);
        } else {
            setAgreChkState((prev) => prev.filter(item => item !== name));
        }
    }

    const MbpBnftStateFunc = () => {
        setBnftState(mbpBnftState => !mbpBnftState);
    }

        const trmsMdalOpener = useCallback((e:string|null)=> {
        if(e != null) {
            // EtcCtxtApi("CTNT_KIND_TRMS", e, "MGP").then((resp)=>{
            //     setTrmsMktgState(resp.apiBody.ctxt)
            // });
            setTrmsMdalCtxtState(e);
            switch(e) {
                case 'TRMS_USE':
                    setTrmsMdalTitlState(langData&&langData.GLB_TRMS_TRM_USE_TITL_00);
                    break;
                case 'TRMS_PRV_PLC':
                    setTrmsMdalTitlState(langData&&langData.GLB_FTR_PRIVACY_MAIN_BTN_00);
                    break;
                case 'TRMS_TRNSF_ABRD':
                    setTrmsMdalTitlState(langData&&langData.GLB_TRMS_TRNSF_ABRD_TITL_00);
                    break;
                default:
                    setTrmsMdalTitlState("");
                    break;
            }
            setTrmsMdalState(true);
            return;
        }
        setTrmsMdalState(false);
    },[langData]);
    // Fire register-start analytics once on initial render.
    useEffect( () => {
        if (window.fbq) window.fbq('trackCustom', 'BBO_FB_Register_Start');
        const tsKst = getKstTimestamp();
        const adPayload = fetchAdPayload( 'BBO');
        gtmPush(`BBO_GA_Register_Start`, {
            ts: tsKst,
            ...adPayload,
        });
    },[]);

    // Initialize page state and auth callback hooks.
    useEffect( () => {
        // update joinTypeCd from location.state when location changes
        try {
            const locState = (location && (location as any).state) ? (location as any).state : null;
            const jt = locState && locState.joinTypeCd ? locState.joinTypeCd : null;
            if (jt && prevJoinTypeRef.current !== jt) {
                setJoinTypeCd(jt);
                console.log('locationState.joinTypeCd', jt);
                prevJoinTypeRef.current = jt;
            }
        } catch (e) {}
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                setIdentMthCd("MBP");
            });
        }
        const serchParamsFunc = () => {
            return new URLSearchParams(location.search);
        }
        let query =serchParamsFunc();
        let getCertNum = query.get("i");
        if(getCertNum != null) {
            MbpAthnTknInqApi(getCertNum).then((resp)=>{
                kmcRespFunc(resp.apiBody.apiTkn,resp.apiBody.certNum)
            })
        }
        // emlValYnFunc();
        // setLoginIdAlertTxt(langData&&langData.MEMB_JOIN_ID_INPUT_DESC_00);
        window.kmcRespFunc = kmcRespFunc;
        return () => {
            try { window.kmcRespFunc = undefined; } catch (e) {}
        };
    },[location, langData]);
    const LoginIdDupChkFunc = async () => {
        // Reject IDs that start or end with special chars (._-).
        if(/^[._-]|[._-]$/.test(loginIdInputVal)) {
            setLoginIdAlertState("N");
            setLoginIdAlertTxt(langData && langData.MEMB_JOIN_ID_INVALID_00 || "특수문자로 시작하거나 끝날수 없습니다.");
            return;
        }
        
        if(!loginIdRole.test(loginIdInputVal)) {
            setLoginIdAlertState("N");
            setLoginIdAlertTxt(langData&&langData.MEMB_JOIN_ID_INPUT_LBL_00);
            return;
        }

        try {
            // debug: trace start
            // eslint-disable-next-line no-console
            console.debug('LoginIdDupChkFunc start', { loginIdInputVal });

            const token = await getToken('dupcheck');
            // eslint-disable-next-line no-console
            console.debug('reCAPTCHA token for dupcheck', { token: token ? '[RECEIVED]' : '[EMPTY]' });

            const resp:any = await LoginIdDupChkApi(loginIdInputVal, token);
            // eslint-disable-next-line no-console
            console.debug('LoginIdDupChkApi resp', resp);

            switch(resp.apiHdr.code) {
                case "ATHN2304":
                    setLoginIdAlertState("N");
                    setLoginIdRsltVal(null);
                    loginIdInputDesc = langData && langData.COMM_CPTCH_ERROR_DESC_00 || "	reCAPTCHA 실행 실패. 잠시 후 다시 시도해주세요.";
                break;
                case "COMM3013":
                    setLoginIdAlertState("N");
                    setLoginIdRsltVal(null);
                    loginIdInputDesc = langData && langData.MEMB_JOIN_ID_INPUT_LBL_04;
                    break;
                case "COMM0000":
                    if(resp.apiBody.yn == "Y"){
                        setLoginIdAlertState("N");
                        setLoginIdRsltVal(null);
                        loginIdInputDesc = langData && langData.MEMB_JOIN_ID_INPUT_LBL_02;
                    } else {
                        setLoginIdAlertState("Y");
                        loginIdInputDesc = langData && langData.MEMB_JOIN_ID_INPUT_LBL_03;
                        setLoginIdRsltVal(loginIdInputVal);
                    }
                    break;
                default:
                    setLoginIdAlertState("N");
                    setLoginIdRsltVal(null);
                    loginIdInputDesc = langData && langData.COMM_MAIN_RSLT_DESC_00;
                    break;
            }

            setLoginIdAlertTxt(loginIdInputDesc);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('LoginIdDupChkFunc error', e);
            setLoginIdAlertState("N");
            setLoginIdAlertTxt((langData && langData.COMM_MAIN_RSLT_DESC_00) || '오류가 발생했습니다.');
        }
    }
    const FormValChkFunc = (identMthCd:string): boolean => {
        if(joinTypeCd != "SSO") {
            if(loginIdRsltVal == null||!loginIdRole.test(loginIdInputVal)){
                openResultModal(langData.MEMB_JOIN_MDAL_MAIN_DESC_00);
                return false;
            }
            if(passwdRsltVal == null||!passWdRole.test(passwdRsltVal)){
                openResultModal(langData.MEMB_JOIN_MDAL_MAIN_DESC_01);
                return false;
            }
        }
        if(identMthCd =="EML") {
            // if(!rlnmInputVal) {
            //     openResultModal(langData.MEMB_JOIN_RLNM_INPUT_LBL_00);
            //     return false;
            // }
            // if(!dobInputVal || !dobRole.test(dobInputVal)) {
            //     openResultModal(langData.MEMB_JOIN_MDAL_MAIN_DESC_02);
            //     return false;
            // }
            // if(gndrKindCd== null) {
            //     openResultModal(langData.MEMB_JOIN_MDAL_MAIN_DESC_03);
            //     return false;
            // }
        }
        // if(!membNickNameRsltVal || membNickNameRsltVal.length < 1 || membNickNameRsltVal.length > 30) {
        //     openResultModal(langData.MEMB_JOIN_MDAL_MAIN_DESC_04);
        //     return false;
        // }
        if(!agreChkState.includes('agreStipulation')) {
            openResultModal(langData?.MEMB_JOIN_TRMS_AGRE_CHK_00 || "이용약관 동의(필수)");
            return false;
        }
        if(!agreChkState.includes('agrePrivacyPolicy')) {
            openResultModal(langData?.MEMB_JOIN_TRMS_AGRE_CHK_00 || "개인정보 처리방침 동의(필수)");
            return false;
        }
        if(!agreChkState.includes('agreThirdParty')) {
            openResultModal(langData?.MEMB_JOIN_TRMS_AGRE_CHK_00 || "개인정보 제3자 제공 및 국외 이전 동의(필수)");
            return false;
        }
        return true;
    }
    const { getToken } = useRecaptcha();
    const MembJoinFunc = async () => {
        const isValid = FormValChkFunc(identMthCd);
        if (!isValid) return;

        if (identMthCd !== "EML") return;

        // Debug: ensure required values exist
        // eslint-disable-next-line no-console
        console.debug('MembJoinFunc called', { joinTypeCd, loginIdRsltVal, passwdRsltVal, membRcmdrCdRsltVal, identMthCd });

        try {
            // eslint-disable-next-line no-console
            console.debug('requesting reCAPTCHA token for memb_join');
            const token = await getToken('memb_join');
            // eslint-disable-next-line no-console
            console.debug('received reCAPTCHA token', { token: token ? '[RECEIVED]' : '[EMPTY]' });

            // For SSO joins, backend accepts null loginId/passwd
            const loginParam = joinTypeCd === "SSO" ? null : loginIdRsltVal;
            const passwdParam = joinTypeCd === "SSO" ? null : passwdRsltVal;

            const resp = await CbtMembJoinApi(
                loginParam,
                passwdParam,
                membRcmdrCdRsltVal,
                token,
                joinTypeCd,
            );

            // eslint-disable-next-line no-console

            switch (resp.apiHdr.code) {
                case "ATHN2101":
                    openResultModal(
                        langData && langData.MEMB_JOIN_EML_ATHN_ERROR_00,
                        () => navigate("/membJoin")
                    );
                    return;
                case "ATHN2304":
                    openResultModal(
                        langData && langData.COMM_CPTCH_ERROR_DESC_00 || "	reCAPTCHA 실행 실패. 잠시 후 다시 시도해주세요.",
                        () => navigate("/membJoin")
                    );
                    return;
                return;
                case "MEMB0000":
                    if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Register_Complete');
                    }
                    const tsKst = getKstTimestamp();
                    const adPayload = fetchAdPayload( 'BBO');
                    try {

                        gtmPush('BBO_GA_Register_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Register_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                    navigate("/Connect/membJoinDone", { state: { membNo: resp.apiBody.membNo, membId: loginIdRsltVal, referrer:resp.apiBody.redirectUri }});
                    return;
                default:
                    ApiError(langData, resp.apiHdr.code);
                    break;
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('MembJoinFunc error', e);
            setLoginIdAlertTxt(langData && langData.COMM_MAIN_RSLT_DESC_00 || '	오류가 발생했습니다.');
        }
    }
    
    return(
        
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            app={"app"}
        />
        <Helmet>
            <title>BE@RBRICK CONNECT - Register</title>
        </Helmet>
        <div className="loginInputWrap">
            <div className="membJoinForm">
                    {joinTypeCd !== "SSO" ? (
                    <>
                        <div className='membJoinFormInputLi mt0'>
                               <div className="membJoinFormInputBox">
                                    <input type="text" name='loginIdInput' className='membJoinFormInput' placeholder={langData&&langData.MEMB_JOIN_ID_INPUT_DESC_00} id='loginIdInput' maxLength={30} value={loginIdInputVal} onChange={LoginIdInputValHandler} onFocus={LoginIdFocusHandler}/>
                                    <button className="loginIdDupChk" onClick={()=> LoginIdDupChkFunc()}>
                                        <span>{langData&&langData.MEMB_JOIN_ID_DUP_CHK_00}</span>
                                    </button>
                                </div>
                            <p className={loginIdAlertState == "Y"?"loginAlertTxt colGreen":"loginAlertTxt"}>{loginIdAlertTxt || '\u00A0'}</p>
                        </div>
                        <div className='membJoinFormInputLi'>
                            <div className="membJoinFormInputBox" style={{position: 'relative'}}>
                                <input 
                                    type={showPassword ? "text" : "password"} 
                                    name='PasswdInput' 
                                    className='membJoinFormInput' 
                                    style={{paddingRight: '45px'}}
                                    placeholder={langData&&langData.MEMB_JOIN_PASSWD_INPUT_DESC_00}
                                    id='passwdInput'
                                    maxLength={30} 
                                    value={passwdInputVal} 
                                    onChange={PasswdInputHandler} 
                                    onFocus={PasswdFocusHandler} 
                                    onBlur={PasswdBlurHandler}
                                />
                                <button 
                                    type="button"
                                    className="passwordToggleBtn"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '5px',
                                        minWidth:'30px',
                                        width: '30px',
                                        height: '30px',
                                        filter:"brightness(10)",
                                    }}
                                >
                                    <img 
                                        src={showPassword ? `${process.env.PUBLIC_URL}/images/common/pwOff.png` : `${process.env.PUBLIC_URL}/images/common/pwOn.png`} 
                                        alt={showPassword ? '비밀번호 숨기기' : '비밀번호 보기'}
                                        style={{width: '100%', height: '100%', display: 'block'}}
                                    />
                                </button>
                            </div>
                            <p className={passwdAlertState == "Y"?"loginAlertTxt colGreen":"loginAlertTxt"}>{passwdAlertTxt || '\u00A0'}</p>
                        </div>
                    </>
                    ) : null}
                <div className='membJoinFormInputLi'>
                    <div className="rcmdInputLbl">
                        <p>※ 추천인 등록</p>
                    </div>
                    <div className="membJoinFormInputBox">
                        <input type="text" name='RcmdrCdInput' className='membJoinFormInput' placeholder={langData&&langData.MEMB_JOIN_RCMDR_INPUT_DESC_00} id='RcmdrCdInput' onChange={MembRcmdrCdInputValHandler}/>
                    </div>
                    <p className={rcmdrCdAlertState == "Y"?"loginAlertTxt colGreen":"loginAlertTxt"}>{rcmdrCdAlertTxt}</p>
                </div>
                        <div className='agreLi' style={{marginTop:"25px", paddingBottom: "30px", borderBottom: "1px solid #ffffff2b"}}>
                            <div>
                                <input type="checkbox" name='agreAll' className='agreChkBox' id='agreAll' checked={agreChkState.length === 3} onChange={e => {
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setAgreChkState(['agreStipulation', 'agrePrivacyPolicy', 'agreThirdParty']);
                                    } else {
                                        setAgreChkState([]);
                                    }
                                }}/>
                                <label htmlFor="agreAll">{langData && langData.MEMB_JOIN_TRMS_AGRE_BTN_ALL || "전체 동의"}</label>
                            </div>
                        </div>
                        <div className='agreLi'>
                            <div>
                                <input type="checkbox" name='agreStipulation' className='agreChkBox' id='agreStipulation' checked={agreChkState.includes('agreStipulation')} onChange={AgreTrmsFunc}/>
                                <label htmlFor="agreStipulation">{langData&&langData.MEMB_JOIN_TRMS_AGRE_BTN_00}</label>
                            </div>
                            <div className='trmsLiModal mdalTrigger' onClick={() => trmsMdalOpener('TRMS_USE')}>
                                <span>{langData&&langData.MEMB_JOIN_VIEW_MORE_BTN_00}</span>
                            </div>
                        </div>
                        <div className='agreLi'>
                            <div>
                                <input type="checkbox" name='agrePrivacyPolicy' className='agreChkBox' id='agrePrivacyPolicy' checked={agreChkState.includes('agrePrivacyPolicy')} onChange={AgreTrmsFunc}/>
                                <label htmlFor="agrePrivacyPolicy">{langData && langData.MEMB_JOIN_PRIVACY_AGRE_BTN_00 || "개인정보 처리방침 동의(필수)"}</label>
                            </div>
                            <div className='trmsLiModal mdalTrigger' onClick={() => trmsMdalOpener('TRMS_PRV_PLC')}>
                                <span>{langData && langData.MEMB_JOIN_VIEW_MORE_BTN_00}</span>
                            </div>
                        </div>
                        <div className='agreLi'>
                            <div>
                                <input type="checkbox" name='agreThirdParty' className='agreChkBox' id='agreThirdParty' checked={agreChkState.includes('agreThirdParty')} onChange={AgreTrmsFunc}/>
                                <label htmlFor="agreThirdParty">{langData&&langData.MEMB_JOIN_TRMS_AGRE_BTN_01}</label>
                            </div>
                            <div className='trmsLiModal mdalTrigger' onClick={() => trmsMdalOpener('TRMS_TRNSF_ABRD')}>
                                <span>{langData&&langData.MEMB_JOIN_VIEW_MORE_BTN_00}</span>
                            </div>
                        </div>
                <div>
                    <button className='loginBtn' onClick={() => MembJoinFunc()}>
                        {langData&&langData.MEMB_JOIN_REG_BTN_00}
                    </button>
                </div>
            </div>
            <div className="capthCpyr">
                {/* reCAPTCHA provided at app root; per-page provider removed */}
                <p>
                    This site is protected by reCAPTCHA and the Google
                    <br />
                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                    <a href="https://policies.google.com/terms"  target="_blank">Terms of Service</a> apply.
                </p>
            </div>
        </div>
        {trmsMdalState && ReactDOM.createPortal(
            <div className='mdalTrmsWrap'>
                <div className='mdalBg' onClick={()=>trmsMdalOpener(null)}></div>
                <div className='mdalTrmsContainer'>
                    <div className='trmsMdalHeader'>
                        <h1>{trmsMdalTitlState}</h1>
                        <div className='trmsMdalCloseBtn' onClick={()=>trmsMdalOpener(null)}><i className="close"></i></div>
                    </div>
                    
                        <TrmsCtxtUi gameSvcCd={"BBO"} trmsKindCd={trmsMdalCtxtState} mdalFunc={()=>trmsMdalOpener(null)}></TrmsCtxtUi>
                    <button className='trmsAgreeBtn' onClick={()=>trmsMdalOpener(null)}>
                        <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                    </button>
                </div>
            </div>,
            document.body
        )}
        </>
    )
    
}

export default AppMembJoinFormUi;
